import { useHasSmartRouting } from '@/store/selectors';

export const useIsSmartRouting = () => {
  const hasSmartRouting = useHasSmartRouting();

  return hasSmartRouting;
};